
<div class="select-container">
  <n-input
    class="select-input"
    v-bind="inputProps"
    :size="size"
    :value="displayValue"
    autocomplete="off"
    @click="toggleDropdown"
    @focus="onFocus"
    @blur="onBlur"
    @input="onSearchInput"
    @keydown="onKeydown"
    @clickiconRight="onClickRightIcon"
    @imageLeftError="onImageError(imageLeft)"
    :iconRight="rightIcon"
    ref="input"
  />
  <n-menu class="dropdown" ref="dropdown" :tippyProps="menuProps">
    <n-list-item
      v-for="(entry, index) in optionEntries"
      :key="index"
      :active="activeElement === index"
      @mousedown.prevent="onSelect(index)"
      @mouseenter="activeElement = index"
    >
      <span v-if="entry.image" class="option-content">
        <img
          class="option-image"
          :src="entry.image"
          alt=""
          width="16"
          height="16"
          loading="lazy"
          decoding="async"
          @error="onImageError(entry.image)"
        />
        <span class="option-label">{{ entry.label }}</span>
      </span>
      <template v-else>{{ entry.label }}</template>
    </n-list-item>
  </n-menu>
</div>
